<p-panel [toggleable]="true" [collapsed]="true">
  <ng-template #header>
    <div>
      <h3>{{ workOrderFabricForm.controls.fabricCode.value }}</h3>
      <div class="row flex-wrap">
        @for (certification of selectedCertifications; track certification.id) {
          <p-tag severity="info">{{ certification.name }}</p-tag>
        }
      </div>
      <p class="w-[90%]">{{ workOrderFabricForm.controls.fabric.value?.longDescription }}</p>
    </div>
  </ng-template>

  <ng-template pTemplate="icons">
    @if (canEdit) {
      <p-button severity="secondary" icon="pi pi-trash" (onClick)="deleteCard()" />
    }
  </ng-template>

  <p-card>
    <div class="col-sm">
      <p-selectbutton [formControl]="dataView" [options]="dataOptions" optionLabel="label" optionValue="value" />
      @if (dataView.value === 'general') {
        @if (!isGreigeOrder) {
          <p-message severity="info">{{
            'Work_Order_Client_PO_Set_At_Color_Level'
              | translateWF
                : 'Client PO set
        at color level'
          }}</p-message>
        }
        <form [formGroup]="workOrderFabricForm" [ngClass]="{ 'mt-2': !isGreigeOrder }">
          <div class="col">
            <p-panel [header]="'Work_Order_Details_Production_Details' | translateWF: 'Production Details'">
              <p-card data-variant="flat">
                <div class="grid-auto-3">
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Garment_Part' | translateWF: 'Garment Part' }}</label>
                    <p-select
                      formControlName="garmetPart"
                      [options]="garmentPartOptions"
                      optionLabel="label"
                      optionValue="value"
                      class="w-full"
                      [ngClass]="{ 'ng-invalid ng-dirty': orderDetailsFormSubmitted && workOrderFabricForm.controls.garmetPart.invalid }"
                    />
                  </div>
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Packing_Type' | translateWF: 'Packing Type' }}</label>
                    <div class="w-full row-sm-start-center">
                      <p-select
                        formControlName="packingType"
                        [options]="packingTypeOptions"
                        optionLabel="label"
                        optionValue="value"
                        class="w-full"
                        [ngClass]="{ 'ng-invalid ng-dirty': orderDetailsFormSubmitted && workOrderFabricForm.controls.packingType.invalid }"
                      />
                      @if (canEditPackingType && !isPackingTypeEditMode) {
                        <p-button class="w-full" severity="secondary" icon="pi pi-pencil" (click)="enterPackingTypeEditMode()" />
                      }
                      @if (isPackingTypeEditMode) {
                        <p-button class="w-full" icon="pi pi-check" (click)="commitPackingTypeEdit()" />
                        <p-button class="w-full" icon="pi pi-times" severity="secondary" variant="outlined" (click)="cancelPackingTypeEdit()" />
                      }
                    </div>
                  </div>
                </div>
              </p-card>
            </p-panel>

            <p-panel [header]="'Work_Order_Details_Client_Specifications' | translateWF: 'Client Specifications'">
              <p-card data-variant="flat">
                <div class="grid-auto-3">
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Client_Fabric_Identifier' | translateWF: 'Client Fabric Identifier' }}</label>
                    <div class="w-full row-sm-start-center">
                      <p-select
                        formControlName="aliasReference"
                        [options]="aliasOptions"
                        optionLabel="label"
                        optionValue="value"
                        class="w-full"
                        [ngClass]="{ 'ng-invalid ng-dirty': orderDetailsFormSubmitted && workOrderFabricForm.controls.aliasReference?.invalid }"
                      />
                      @if (canEdit) {
                        <p-button
                          severity="secondary"
                          icon="pi pi-pencil"
                          [ariaLabel]="'Fabric_Details_Panel_Edit_Aliases' | translateWF: 'Edit Aliases'"
                          (click)="manageAliases()"
                        />
                      }
                    </div>
                  </div>
                  <div class="form-box">
                    <label>{{ 'Work_Order_Details_Fabric_Label' | translateWF: 'Fabric Export Label' }}</label>
                    <csl-dropdown-master-data class="w-full" formControlName="clientRequestedFabricLabelCode" categoryCode="ClientRequestedFabricLabel" [allowCreate]="false" />
                  </div>
                  @if (isGreigeOrder) {
                    <div class="form-box">
                      <label>{{ 'Fabric_Details_Panel_Client_PO' | translateWF: 'Client PO' }}</label>
                      <p-select
                        formControlName="productOrderNumber"
                        [options]="clientProductOrderOptions"
                        optionLabel="label"
                        optionValue="value"
                        class="w-full"
                        [ngClass]="{ 'ng-invalid ng-dirty': orderDetailsFormSubmitted && workOrderFabricForm.controls.productOrderNumber?.invalid }"
                      />
                    </div>
                  }
                </div>
              </p-card>
            </p-panel>
            <p-panel [header]="'Work_Order_Details_Pricing_Quantity' | translateWF: 'Pricing & Quantity'">
              <p-card data-variant="flat">
                <div class="grid-auto-3">
                  @if (isGreigeOrder) {
                    <div class="form-box">
                      <label>{{ 'Work_Order_Details_Unit_Price' | translateWF: 'Unit Price' }}</label>
                      <p-inputnumber
                        fluid=""
                        class="w-full"
                        formControlName="unitPrice"
                        mode="currency"
                        [minFractionDigits]="2"
                        currency="USD"
                        [ngClass]="{ 'ng-invalid ng-dirty': orderDetailsFormSubmitted && workOrderFabricForm.controls.unitPrice.invalid }"
                      />
                    </div>
                  }
                  <div class="form-box">
                    <label>{{ 'Total_Quantity' | translateWF: 'Total Quantity' }}</label>
                    <p-inputGroup>
                      @if (!isGreigeOrder) {
                        <input pInputText [value]="getTotalQuantity() | number: '1.2-2'" class="w-full" [disabled]="true" />
                      } @else {
                        <p-inputnumber
                          formControlName="quantityInUOM"
                          mode="decimal"
                          [minFractionDigits]="2"
                          [maxFractionDigits]="5"
                          class="w-full"
                          [ngClass]="{ 'ng-invalid ng-dirty': orderDetailsFormSubmitted && workOrderFabricForm.controls.quantityInUOM.invalid }"
                        />
                      }
                      <p-inputGroupAddon> {{ uom }} </p-inputGroupAddon>
                    </p-inputGroup>
                  </div>
                  <div class="form-box">
                    <label>{{ 'Total_Cost' | translateWF: 'Total Cost' }}</label>
                    <input pInputText [value]="getTotalCost() | currency" class="w-full" [disabled]="true" />
                  </div>
                </div>
              </p-card>
            </p-panel>
          </div>
        </form>

        @if (!isGreigeOrder) {
          <p-panel [header]="'Fabric_Details_Panel_Colors' | translateWF: 'Colors'">
            <ng-template pTemplate="icons">
              @if (canEdit && !isShortFall) {
                <p-autocomplete
                  field="name"
                  [formControl]="colorSearch"
                  [dropdown]="true"
                  (completeMethod)="colorsTypeAhead($event)"
                  (onSelect)="onSelectColor($event)"
                  [suggestions]="filteredColors"
                  dropdownIcon="pi pi-search"
                  [placeholder]="'Fabric_Details_Panel_Search' | translateWF: 'Search'"
                >
                  <ng-template let-color pTemplate="item">
                    <div class="panel__option" [title]="color.name">
                      {{ color.name }} - {{ color.approvedRecipeNumber || ('Work_Order_Details_No_Approved_Recipe' | translateWF: 'No Approved Recipe') }}
                    </div>
                  </ng-template>
                </p-autocomplete>
              }
            </ng-template>
            <p-card data-variant="flat">
              <div class="col-sm">
                @for (color of workOrderFabricForm.controls.garmetDetails.controls; track $index) {
                  @if (color.value.colorReference) {
                    <app-color-details-card
                      [garmentDetailsForm]="getgarmentDetailsForm(color.value.colorReference)"
                      [color]="getColorByReference(color.value.colorReference)!"
                      [uom]="uom"
                      [orderDetailsFormSubmitted]="orderDetailsFormSubmitted"
                      [clientProductOrders]="clientProductOrders"
                      (removeGarmentDetail)="removeGarmentDetail($event)"
                    />
                  }
                } @empty {
                  <p-message severity="secondary">{{ 'Fabric_Details_Panel_No_Colors' | translateWF: 'No colors assigned.' }}</p-message>
                }
              </div>
            </p-card>
          </p-panel>
        }
      } @else {
        @if (hasGreigeData) {
          <div class="grid-12">
            <div class="span-6">
              <app-card-composition [allCompositions]="allCompositions" [fabricComposition]="fabricComposition" />
            </div>
            <div class="span-6">
              <div class="grid-12">
                <div class="span-6">
                  <label>{{ 'Fabric_Details_Panel_Fabric_Form' | translateWF: 'Fabric Form' }}</label>
                  <input type="text" pInputText [value]="fabricFormValue" class="w-full" [disabled]="true" />
                </div>
                <div class="span-6">
                  <label>{{ 'Fabric_Details_Panel_GSM' | translateWF: 'GSM' }}</label>
                  <input type="text" pInputText [value]="gramsPerSquareMeter" class="w-full" [disabled]="true" />
                </div>
                <div class="span-6">
                  <label>{{ 'Fabric_Details_Panel_ETE_Width' | translateWF: 'ETE Width' }}</label>
                  <input type="text" pInputText [value]="endToEndWidth" class="w-full" [disabled]="true" />
                </div>
              </div>
            </div>
          </div>
          <p-panel [header]="'Fabric_Details_Panel_Certifications' | translateWF: 'Certifications'">
            <p-card data-variant="compact">
              <p-table [value]="workOrderFabricForm.controls.yarnCertificationDetails.controls" dataKey="yarnCode" [rowHover]="true">
                <ng-template pTemplate="header">
                  <tr>
                    <th>{{ 'Fabric_Details_Panel_PD_Yarn_Code' | translateWF: 'PD Yarn Code' }}</th>
                    <th>{{ 'Fabric_Details_Panel_Description' | translateWF: 'Description' }}</th>
                    <th>{{ 'Fabric_Details_Panel_Use_Percentage' | translateWF: 'Use Percentage' }}</th>
                    <th>{{ 'Fabric_Details_Panel_Certifications' | translateWF: 'Certifications' }}</th>
                    <th>{{ 'Client_PO_ItemMaster' | translateWF: 'Item Master' }}</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-yarnControl>
                  @let itemMaster = getItemMasterByUniqueKey(yarnControl.value.yarnCode, workOrderFabricForm.controls.fabricCode.value);
                  <tr>
                    <td>{{ yarnControl.value.yarnCode }}</td>
                    <td>{{ getYarnByCode(yarnControl.value.yarnCode)?.longDescription }}</td>
                    <td>{{ yarnControl.value.usePercentage }}%</td>
                    <td>
                      <p-multiSelect
                        appendTo="body"
                        [options]="yarnCertificationsMap[yarnControl.value.yarnCode] || emptyArray"
                        (onChange)="onCertificationChange($event, yarnControl.value.yarnCode, workOrderFabricForm.controls.fabricCode.value)"
                        optionLabel="name"
                        optionValue="id"
                        display="chip"
                        [placeholder]="'Fabric_Details_Panel_Select_Certifications' | translateWF: 'Select certifications'"
                        [formControl]="yarnControl.controls.certificationReferences"
                      ></p-multiSelect>
                    </td>
                    <td>
                      {{
                        itemMaster?.itemCode
                          ? itemMaster!.fieldToDisplay
                          : ('Fabric_Details_Panel_Not_Found'
                            | translateWF
                              : 'Not
                  Found')
                      }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </p-card>
          </p-panel>
        } @else {
          <p-message severity="secondary">{{
            'Fabric_Details_Panel_No_Composition'
              | translateWF
                : 'No fabric composition
        data
        available.'
          }}</p-message>
        }
      }
    </div>
  </p-card>
</p-panel>
